module.exports = __webpack_public_path__ + "static/cytec-logo-0be8ab47557dd1540cd52e9c44d08825.png";